export default __webpack_public_path__ + "static/media/before-after.520f50c0.png";